/**
 * @generated SignedSource<<2a80f27515c61ac5637c2ad8e67bb1e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InterviewChatSection_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OralInterviewMessage",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InterviewChatMessage_message"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerOralInterview",
  "abstractKey": null
};

node.hash = "9fc549b6281c128a8867ad8d0df92b5b";

module.exports = node;
